import gql from 'graphql-tag';

const DeleteDriverAccountSelf = gql(/* GraphQL */ `
  mutation DriverAccountSelfDelete($input: DriverAccountSelfDeleteInput!) {
    driverAccountSelfDelete(input: $input) {
      errors
    }
  }
`);

export default DeleteDriverAccountSelf;
